module.exports = "pegasus_template/assets/frame-large-linkedin.png";